import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusGetEmailOptional: null,
    statusSetEmailOptional: null,
    activarEmailOptional: [],
    activarEmailOptionalConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setEmailOptional (state, data) {
      state.activarEmailOptional = data
    },
    setResponseUpdateEmailOptionalConfig (state, data) {
      state.statusSetEmailOptional = data
    },
    setResponseGetEmailOptional (state, data) {
      state.statusGetEmailOptional = data
    },
    setResponseEmailOptionalMsg (state, data) {
      state.activarEmailOptionalConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getEmailOptional ({ commit }, data) {
      let params = 'IdCompania=' + -1
      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        console.log(JSON.parse(atob(localStorage.getItem('uid'))).rol.trim);
        console.log('Desarrollador');

        params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      } else {
        params = 'IdCompania=' + data.IdCompania
      }

      const endpoint = '/api/getEmailOptional?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setEmailOptional', response.data.Data)
          if (response.data.Error) {
            commit('setResponseGetEmailOptional', true)
            commit('setResponseEmailOptionalMsg', 'Hubo un error obteniendo la configuración de correo opcional. Intentelo nuevamente.')
          } else {
            commit('setResponseGetEmailOptional', false)
            commit('setResponseEmailOptionalMsg', 'Configuración de correo opcional consultada exitosamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetEmailOptional', true)
          commit('setResponseEmailOptionalMsg', 'No pudo obtener  configuración de correo opcional. Intentelo nuevamente.')
          console.log(error.message)
        })
    },
    updateEmailOptional ({ commit }, data) {
      const endpoint = '/api/updateEmailOptional'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        data.IdCompania = JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          console.log(response)
            if (response.data.Error) {
              commit('setResponseUpdateEmailOptionalConfig', true)
              commit('setResponseEmailOptionalMsg', 'Hubo un error guardando la configuración de correo opcional. Intentelo nuevamente.')
            } else {
              commit('setResponseUpdateEmailOptionalConfig', false)
              commit('setResponseEmailOptionalMsg', 'Configuración de cambio de correo opcional guardada exitosamente.')
            }
        })
        .catch(function (error) {
          commit('setResponseUpdateEmailOptionalConfig', true)
          commit('setResponseEmailOptionalMsg', 'No pudo obtener información de la configuración de correo opcional.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateEmailOptionalConfig', data)
    },
    statusGetEmailOptional ({ commit }, data) {
      commit('setResponseGetEmailOptional', data)
    },
  },
}
